import { Box, styled, Typography } from '@mui/material';

import { CloseIcon } from '../Icons';

export const ToastCloseIcon = styled(CloseIcon)(({ theme }) => ({
  color: theme.palette.grey[400],
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  cursor: 'pointer',
}));

export const ToastIconWrapper = styled(Box)(({ theme, color }) => {
  let iconcolor;

  if (color === 'success') {
    iconcolor = theme.palette.success.main;
  }
  if (color === 'warning') {
    iconcolor = theme.palette.success.main;
  }
  if (color === 'error') {
    iconcolor = theme.palette.error.main;
  }
  if (color === 'info') {
    iconcolor = theme.palette.primary.main;
  }

  return `
      color: ${iconcolor || theme.palette.common.white};
      margin-right: 12px;
      height: 100%;
      font-size: 18px;
      align-items: center;
      justify-content: center;
  `;
});

export const AlertTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 14,
  lineHeight: 1.714,
}));

export const AlertMessage = styled(Typography)(({ theme, contained }) => ({
  opacity: contained ? 1 : 0.8,
  fontWeight: contained ? 500 : 400,
  fontSize: 12,
  lineHeight: 2,
  color: contained ? theme.palette.common.white : theme.palette.text.primary,
}));
